import moment from "moment";
import Vue from "vue";

Vue.filter("formatarData", (value) => {
  if (!value) return "";
  let timestamp = value; // firebase data
  if (typeof value == "string" && value?.match(/^20\d{2}-[0-1]\d-[0-3]\d$/g))
    timestamp = moment(value, "YYYY-MM-DD")?.toDate();
  if (
    typeof value == "string" &&
    value?.match(/^([0-2][0-9]|3[0-1])-(0[1-9]|1[0-2])-\d{4}$/)
  )
    timestamp = moment(value, "DD-MM-YYYY")?.toDate();
  let myDate = new Date();
  if (timestamp._seconds) {
    myDate = new Date(timestamp._seconds * 1000); // date object
  } else if (timestamp.seconds) {
    myDate = new Date(timestamp.seconds * 1000); // date object
  } else {
    myDate = new Date(timestamp); // date object
  }

  return moment(myDate.toISOString().substring(0, 10)).format("MM/YYYY");
});

Vue.filter("formatarDate", (value) => {
  if (!value) return "";
  let timestamp = value; // firebase data
  if (typeof value == "string" && value?.match(/^20\d{2}-[0-1]\d-[0-3]\d$/g))
    timestamp = moment(value, "YYYY-MM-DD")?.toDate();
  if (
    typeof value == "string" &&
    value?.match(/^([0-2][0-9]|3[0-1])-(0[1-9]|1[0-2])-\d{4}$/)
  )
    timestamp = moment(value, "DD-MM-YYYY")?.toDate();
  let myDate = new Date();
  if (timestamp._seconds) {
    myDate = new Date(timestamp._seconds * 1000); // date object
  } else if (timestamp.seconds) {
    myDate = new Date(timestamp.seconds * 1000); // date object
  } else {
    myDate = new Date(timestamp); // date object
  }
  return moment(myDate.toISOString().substring(0, 10)).format("DD/MM/YYYY");
});
Vue.filter("formatarDateTime", (value) => {
  if (!value) return "";
  let timestamp = value; // firebase data
  if (typeof value == "string" && value?.match(/^20\d{2}-[0-1]\d-[0-3]\d$/g))
    timestamp = moment(value, "YYYY-MM-DD")?.toDate();
  if (
    typeof value == "string" &&
    value?.match(/^([0-2][0-9]|3[0-1])-(0[1-9]|1[0-2])-\d{4}$/)
  )
    timestamp = moment(value, "DD-MM-YYYY")?.toDate();
  let myDate = new Date();
  if (timestamp._seconds) {
    myDate = new Date(timestamp._seconds * 1000); // date object
  } else if (timestamp.seconds) {
    myDate = new Date(timestamp.seconds * 1000); // date object
  } else {
    myDate = new Date(timestamp); // date object
  }
  return moment(myDate).format("DD/MM/YYYY HH:mm");
});
Vue.filter("formatStatus", (value) => {
  if (!value) return "";

  if (value === "paga" || value === "succeeded" || value === "paid") {
    return "done_outline";
  } else if (
    value === "aberta" ||
    value === "pending" ||
    value === "waiting_payment" ||
    value === "opened"
  ) {
    return "schedule";
  } else if (value === "overdue" || value === "refused") {
    return "schedule";
  } else if (value === "refused") {
    return "credit_card_off";
  } else if (value === "free") {
    return "card_giftcard";
  } else if (value === "failed") {
    return "highlight_off";
  } else if (value === "processing") {
    return "hourglass_bottom";
  } else if (value === "generation") {
    return "hourglass_top";
  } else if (value === "parceled") {
    return "list";
  } else {
    return "help_outline";
  }
});

Vue.filter("formatPersonType", (value) => {
  if (!value) return "";

  if (value === "pf") {
    return "Pessoa Física";
  } else if (value === "pj") {
    return "Pessoa Jurídica";
  }
});

Vue.filter("FormatPlanStatus", (value) => {
  if (!value) return "";
  value = value.toUpperCase();
  if (value === "ACTIVATED") {
    return "ATIVADO";
  } else if (value === "DISABLED") {
    return "DESATIVADO";
  }
});

Vue.filter("formatUserStatus", (value) => {
  if (!value) return "";
  value = value.toUpperCase();
  if (value === "ATIVO") {
    return "ATIVO";
  } else if (value === "INATIVO" || value === "CANCELED") {
    return "CANCELADO";
  } else if (value === "SENDED_PROPOSAL") {
    return "PROPOSTA ENVIADA";
  } else if (value === "REQUEST_PROPOSAL") {
    return "PROPOSTA SOLICITADA";
  } else if (value === "NOT_HOLDER") {
    return "NÃO É O TITULAR";
  } else if (value === "AGUARDANDO_CONTA") {
    return "AGUARDANDO CONTA";
  } else if (value === "MULTIPLAS_CONTAS") {
    return "MULTIPLAS INSTALAÇÕES";
  } else if (value === "SEM_RETORNO") {
    return "SEM RETORNO";
  } else if (value === "QUALIFICAR_MANUALMENTE") {
    return "QUALIFICAR MANUALMENTE";
  } else if (value === "PAYMENT_METHOD_NOT_SELECTED") {
    return "SEM FORMA DE PAGTO";
  } else if (value === "IN_QUEUE") {
    return "NA FILA";
  } else if (value === "CANCELING") {
    return "EM CANCELAMENTO";
  } else if (value === "WAIT_ADD_CREDIT_CARD") {
    return "AGUARDANDO INCLUSAO DE CARTAO";
  } else if (value === "AGUARDANDO_NRO_INSTALACAO") {
    return "AGUARDANDO NRO INSTALAÇÃO";
  } else if (value === "VALIDAR_DOCUMENTO") {
    return "VALIDAR DOCUMENTO";
  } else if (value === "AGUARDANDO_DOCUMENTO") {
    return "AGUARDANDO DOCUMENTO";
  } else if (value === "NAO_INTERESSADO") {
    return "NÃO INTERESSADO";
  } else if (value === "DESQUALIFICAR") {
    return "DESQUALIFICADO";
  } else if (value === "QUALIFICAR") {
    return "QUALIFICAR";
  } else if (value === "VALIDAR_CONTA") {
    return "VALIDAR CONTA/UC";
  } else {
    return value;
  }
});

Vue.filter("formatUserStatusColor", (value) => {
  if (!value) return "";
  value = value.toUpperCase();
  if (value === "ATIVO") {
    return "green";
  } else if (value === "INATIVO" || value === "CANCELED") {
    return "red";
  } else if (value === "SENDED_PROPOSAL") {
    return "grey";
  } else if (value === "REQUEST_PROPOSAL") {
    return "grey";
  } else if (value === "NOT_HOLDER") {
    return "grey";
  } else if (value === "AGUARDANDO_CONTA") {
    return "grey";
  } else if (value === "MULTIPLAS_CONTAS") {
    return "grey";
  } else if (value === "SEM_RETORNO") {
    return "black";
  } else if (value === "QUALIFICAR_MANUALMENTE") {
    return "orange";
  } else if (value === "PAYMENT_METHOD_NOT_SELECTED") {
    return "orange";
  } else if (value === "IN_QUEUE") {
    return "orange";
  } else if (value === "CANCELING") {
    return "red";
  } else if (value === "WAIT_ADD_CREDIT_CARD") {
    return "orange";
  } else if (value === "AGUARDANDO_NRO_INSTALACAO") {
    return "grey";
  } else {
    return "success";
  }
});

Vue.filter("formatUserStatusDesc", (value) => {
  if (!value) return "";
  value = value.toUpperCase();
  if (value === "ATIVO") {
    return "O membro passou pelo processo de qualificação e já está apto a receber energia limpa";
  } else if (value === "INATIVO" || value === "CANCELED") {
    return "O membro está cancelado em nosso sistema.";
  } else if (value === "SENDED_PROPOSAL") {
    return "Proposta foi enviada ao membro";
  } else if (value === "REQUEST_PROPOSAL") {
    return "PROPOSTA SOLICITADA";
  } else if (value === "NOT_HOLDER") {
    return "A inscrição foi realizada por um CPF que não foi identificado na concessionária";
  } else if (value === "AGUARDANDO_CONTA") {
    return (
      "A inscrição foi realizada, porém, ainda não foi encontrada conta na Cemig. " +
      "\nFoi solicado ao inscrito que envie uma conta de luz.\n" +
      "\nSerão enviados 3 mensagens consecutivas e depois uma por semana.\n" +
      "\nO sistema tentará realizar a qualificação automatica 3 dias seguidos e depois uma vez por semana.\n"
    );
  } else if (value === "MULTIPLAS_CONTAS") {
    return "MULTIPLAS INSTALAÇÕES";
  } else if (value === "SEM_RETORNO") {
    return "SEM RETORNO";
  } else if (value === "QUALIFICAR_MANUALMENTE") {
    return "Ocorreu algum erro durante o processo de qualificação, por favor, abrir ocorrência ao time de qualificação";
  } else if (value === "QUALIFICAR") {
    return "Inscrição aguardando qualificação, o processo roda normalmente de 30 em 30 minutos, caso ultrapasse 4 horas abrir ocorrência ao time de qualificação.";
  } else if (value === "PAYMENT_METHOD_NOT_SELECTED") {
    return "SEM FORMA DE PAGTO";
  } else if (value === "IN_QUEUE") {
    return "NA FILA";
  } else if (value === "CANCELING") {
    return "Membro solicitou o cancelamento e está aguardando ser substituído na concessionária. O prazo maximo para isso é 90 dias da data de solicitação.";
  } else if (value === "WAIT_ADD_CREDIT_CARD") {
    return "AGUARDANDO INCLUSAO DE CARTAO";
  } else if (value === "AGUARDANDO_NRO_INSTALACAO") {
    return "A inscrição foi realizada por um CPF que não foi identificado na concessionária, aguardando informação sobre o numero de instalação.";
  } else if (value === "VALIDAR_DOCUMENTO") {
    return "VALIDAR DOCUMENTO";
  } else if (value === "AGUARDANDO_DOCUMENTO") {
    return "AGUARDANDO DOCUMENTO";
  } else {
    return value;
  }
});

Vue.filter("formatStatusBillingColor", (value) => {
  if (!value) return "";

  if (value === "paga" || value === "succeeded" || value === "paid") {
    return "green";
  } else if (value === "aberta" || value === "pending") {
    return "grey";
  } else if (value === "overdue" || value === "refused") {
    return "red";
  } else if (value === "free") {
    return "blue";
  } else if (value === "pending_approval") {
    return "blue";
  } else if (value === "failed") {
    return "red";
  } else if (value === "processing") {
    return "orange";
  } else if (value === "generation") {
    return "orange";
  } else if (value === "canceled") {
    return "black";
  } else if (value === "error") {
    return "red";
  } else if (value === "reprocessing") {
    return "red";
  } else if (value === "postponed") {
    return "#FFC000";
  } else {
    return "teal";
  }
});

Vue.filter("formatCurrency", (value) => {
  if (!value) return "";
  let val = (value * 1).toFixed(2).replace(".", ",");
  return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
});

Vue.filter("formatCompetence", (value) => {
  let year = value.toString().substring(0, 4);
  let month = value.toString().substring(4, 6);
  return month + year;
});

Vue.filter("formatCompetenceTraco", (value) => {
  let year = value.toString().substring(0, 4);
  let month = value.toString().substring(5, 7);
  return month + "/" + year;
});

Vue.filter("formatTransactionStatus", (value) => {
  if (!value) return "";
  else if (value === "processing") return "PROCESSANDO";
  else if (value === "authorized") return "AUTORIZADA";
  else if (value === "paid") return "PAGO";
  else if (value === "pending_approval") return "EM ANÁLISE";
  else if (value === "refunded") return "ESTORNADA";
  else if (value === "waiting_payment") return "AGUARDANDO PAGAMENTO";
  else if (value === "opened" || value === "pending") return "PENDENTE";
  else if (value === "pending_refund") return "AGUARDANDO ESTORNO";
  else if (value === "refused") return "CARTÃO RECUSADO";
  else if (value === "chargedback") return "CHARGEBACK";
  else if (value === "analyzing") return "EM ANALISE";
  else if (value === "pending_review") return "REVISÃO MANUAL";
  else if (value === "free") return "ABONADO";
  else if (value === "overdue") return "ATRASADA";
  else if (value === "reprocessing") return "REPROCESSAR";
  else if (value === "generating") return "GERANDO FATURA";
  else if (value === "canceled") return "ATRASADA";
  else if (value === "parceled") return "PARCELADA";
  else if (value === "in_queue") return "FILA DE FATURAMENTO";
  else if (value === "error") return "ERRO";
  else if (value === "free_pending") return "PENDENTE P/ ABONO";
  else if (value === "postponed") return "ADIADA";
  else return value;
});

Vue.filter("formatInt", (value) => {
  if (!value) return 0;
  return Number(value).toFixed(0);
});

Vue.filter("formatUCStatus", (value) => {
  if (!value) return "";

  if (value.toLowerCase() === "activated" || value === "ATIVO") {
    return "Ativo";
  } else if (
    value.toLowerCase() === "inactivated" ||
    value.toLowerCase() === "canceled"
  ) {
    return "Cancelado";
  } else if (value.toLowerCase() === "canceling") {
    return "Em cancelamento";
  } else if (value.toLowerCase() === "interrupting") {
    return "Interrompendo Fornecimento";
  } else if (value.toLowerCase() === "contract_not_signed") {
    return "Contrato Não Assinado";
  } else if (value.toLowerCase() === "awaiting_contract_generation") {
    return "Gerando Contrato";
  } else if (value.toLowerCase() === "awaiting_signature") {
    return "Aguardando Assinatura";
  } else if (value.toLowerCase() === "error_debts") {
    return "Aguardando conta";
  } else if (value.toLowerCase() === "error") {
    return "Erro";
  } else if (value.toLowerCase() === "bill_not_found") {
    return "Conta não encontrada";
  } else if (value.toLowerCase() === "disqualified") {
    return "Desqualificado";
  } else if (value.toLowerCase() === "pending") {
    return "Pendente";
  } else if (value.toLowerCase() === "qualified") {
    return "Qualificado";
  } else if (value.toLowerCase() === "interrupted") {
    return "Fornecimento Interrompido";
  } else {
    return value;
  }
});

Vue.filter("formatUCStatusColor", (value) => {
  if (!value) return "";

  if (value === "activated") {
    return "green";
  } else if (value === "inactivated" || value === "canceled") {
    return "red";
  } else if (value.toLowerCase() === "interrupting") {
    return "grey";
  } else if (value.toLowerCase() === "interrupted") {
    return "grey darken-5";
  } else if (value.toLowerCase() === "awaiting_contract_generation") {
    return "teal lighten-1";
  } else if (value.toLowerCase() === "awaiting_signature") {
    return "purple darken-1";
  } else if (value === "canceling") {
    return "orange darken-3";
  } else if (value.toLowerCase() === "error") {
    return "red";
  } else if (value.toLowerCase() === "bill_not_found") {
    return "grey";
  } else if (value.toLowerCase() === "disqualified") {
    return "red";
  } else if (value.toLowerCase() === "pending") {
    return "grey";
  } else if (value.toLowerCase() === "qualified") {
    return "blue";
  }
});

Vue.filter("formatUCStatusIcon", (value) => {
  if (!value) return "";

  if (value === "activated") {
    return "person";
  } else if (value === "inactivated" || value === "canceled") {
    return "person_remove";
  } else if (value === "canceling") {
    return "person_outline";
  }
});

Vue.filter("formatPaymentType", (value) => {
  if (!value) return "";

  if (value === "boleto") {
    return "Boleto";
  } else if (value === "pix") {
    return "Pix";
  } else if (value === "credit_card" || value === "credit_card") {
    return "Cartão de Crédito";
  }
});

Vue.filter("formatPaymentTypeIcon", (value) => {
  if (!value) return "";

  if (value === "boleto") {
    return "mdi-barcode";
  } else if (value === "pix_with_link") {
    return "qr_code";
  } else if (value === "credit_card" || value === "credit_card") {
    return "credit_card";
  }
});

Vue.filter("clearPhone", (value) => {
  if (!value) return "";
  value = value.replace(/[^\d]/g, "");
  console.log(value);
  if (value.length >= 13 && value.substring(0, 2) == "55")
    return value.substring(2, value.length);
  return value;
});

Vue.filter("paymentTypeIcon", (value) => {
  if (!value) return "";
  value = value.replace(/[^\d]/g, "");
  if (value === "credit_card") return "payment";
  else if (value === "pix") return "qr_code_2";
  else return "mdi-barcode";
});

Vue.filter("formatCurrencyInteger", (value) => {
  let val = (value * 1).toFixed(0);
  return val;
});

Vue.filter("formatCurrencyDecimal", (value) => {
  let val = (value * 1).toFixed(2).split(".")[1];
  return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
});

Vue.filter("batchStatus", (value) => {
  if (!value) return "";

  if (value === "creating") {
    return "Criando Lote";
  } else if (value === "created") {
    return "Lote Criado";
  } else if (value === "sent") {
    return "Lote Enviado";
  } else if (value === "accepted") {
    return "Lote Aceito";
  } else if (value === "completed") {
    return "Lote Completado";
  } else if (value === "payment_error") {
    return "Erro no Lote";
  } else if (value === "on_hold") {
    return "Lote em Espera";
  } else return value;
});

Vue.filter("batchStatusColor", (value) => {
  if (!value) return "";

  if (value === "waiting_payment") {
    return "warning";
  } else if (value === "created") {
    return "cyan";
  } else if (value === "sent") {
    return "green lighten-3";
  } else if (value === "accepted") {
    return "blue darken-3";
  } else if (value === "completed") {
    return "success";
  } else if (value === "payment_error") {
    return "error";
  } else return "grey darken-4";
});

Vue.filter("billingBatchStatus", (value) => {
  if (!value) return "";

  if (value === "waiting_payment") {
    return "Aguardando Pagamento";
  } else if (value === "waiting_batch_assignment") {
    return "Esperando ingressar no Lote";
  } else if (value === "assigned_to_batch") {
    return "Adicionado no Lote";
  } else if (value === "batch_sent") {
    return "Enviado no Lote";
  } else if (value === "batch_accepted") {
    return "Aceito no Lote";
  } else if (value === "payment_completed") {
    return "Pagamento Completado";
  } else if (value === "payment_error") {
    return "Erro ao Pagar";
  } else if (value === "paid_manually") {
    return "Pago Manualmente";
  } else return value;
});

Vue.filter("billingBatchError", (value) => {
  if (!value) return "";
  else if (
    value >=
    "REGISTRO REJEITADO TRIBUTO NÃO LIQUIDÁVEL VIA SISPAG OU NÃO CONVENIADO COM ITAÚ"
  ) {
    return "Erro de Agendamento";
  } else if (value.includes("INSUFICIÊNCIA") && value.includes("SALDO")) {
    return "Erro de Pagamento";
  } else if (value === "PAGAMENTO CANCELADO POR FALTA DE AUTORIZAÇÃO") {
    return "Erro de Autorização";
  } else return value;
});

Vue.filter("billingBatchStatusColor", (value) => {
  if (!value) return "";

  if (value === "waiting_payment") {
    return "warning";
  } else if (value === "waiting_batch_assignment") {
    return "cyan";
  } else if (value === "assigned_to_batch") {
    return "green lighten-3";
  } else if (value === "batch_sent") {
    return "green lighten-3";
  } else if (value === "batch_accepted") {
    return "blue darken-3";
  } else if (value === "payment_completed") {
    return "success";
  } else if (value === "paid_manually") {
    return "success";
  } else if (value === "payment_error") {
    return "error";
  } else {
    return "grey darken-4";
  }
});

Vue.filter("formatJuntos", (value) => {
  if (!value) return "";

  if (value === "enercred") {
    return "Juntos Energia";
  } else {
    return value;
  }
});

Vue.filter("formatKWCurrency", (value) => {
  if (!value || value === "") return "";
  const new_value = Number(value);
  return new_value.toFixed(8).replace(".", ",");
});

Vue.filter("formatStatusReason", (value) => {
  let reasons = [
    { text: "Mudou de concessionária", value: "new_utility_company" },
    { text: "Instalou painel próprio", value: "own_panel" },
    { text: "Mudou o consumo abaixo do mínimo", value: "low_consumption" },
    { text: "Fornecimento Duplicado", value: "duplicated_supply" },
    { text: "Mudou para baixa renda", value: "low_income" },
    // { text: "Está infeliz com o serviço", value: "unhappy" },
    {
      text: "Deseja receber boleto impresso",
      value: "receive_printed_invoice",
    },
    {
      text: "Impossibilidade de alteração da data de pagamento;",
      value: "cant_change_payment_date",
    },
    { text: "Desconto insuficiente", value: "insufficient_discount" },
    { text: "Inadimplência", value: "non_payment" },
    { text: "Cancelado na concessionária", value: "utility_company_canceled" },
    { text: "Mudou de Endereço", value: "address_changed" },
    { text: "Contrato Rejeitado", value: "rejected_contract" },
    { text: "Conta retida", value: "retained_account" },
    { text: "Demora no Fornecimento", value: "supply_delay" },
    { text: "Venda incorreta", value: "wrong_sale" },
    { text: "Todas as UCS canceladas", value: "all_ucs_canceled" },
    { text: "Contas separadas", value: "separate_accounts" },
    { text: "Análise de Adesão", value: "sale_analysis" },
    {
      text: "Pendência de documentação na venda",
      value: "pending_documentation",
    },
    {
      text: "Pendências com a concessionária",
      value: "pending_utility_company",
    },
    {
      text: "Troca de titularidade",
      value: "change_of_holder",
    },
    { text: "Aderiu ao concorrente", value: "competitor" },
  ];

  if (!value || value === "") return "";
  const new_value = search(value, reasons);
  return new_value;
});

Vue.filter("FormatPowerPlantStatus", (value) => {
  let reasons = [
    { text: "Ativo", value: "active" },
    { text: "Ativo", value: "activated" },
    { text: "Em Construção", value: "construction" },
    { text: "Aguardando Início Faturamento", value: "waiting" },
    { text: "Em Operação", value: "operating" },
    { text: "Contrato Encerrado", value: "contract_terminated" },
    { text: "Renegociação", value: "renegotiation" },
    { text: "Cancelada", value: "canceled" },
    { text: "Aguardando", value: "waiting" },
    { text: "Análise Jurídica", value: "legal_analysis" },
  ];

  if (!value || value === "") return value;
  const new_value = search(value, reasons);
  return new_value;
});

Vue.filter("statusColor", (value) => {
  if (!value) return "";
  if (value === "ATIVO") return "green";
  else if (value === "INATIVO") return "red";
  else if (value === "QUALIFICAR") return "blue";
  else return "orange";
});

Vue.filter("formatContractType", (value) => {
  let reasons = [
    { value: "comodate", text: "Comodato" },
    { value: "additive", text: "Aditivo" },
    { value: "location", text: "Locação" },
    { value: "variable_remuneration", text: "O&M" },
    { value: "cancellation", text: "Distrato" },
    { value: "others", text: "Outros" },
  ];
  if (!value || value === "") return value;
  const new_value = search(value, reasons);
  return new_value;
});

Vue.filter("formatQualificationStatusColor", (value) => {
  if (!value) return "";

  if (value === "activated") {
    return "blue--text darken-1";
  }
  // else if(value === 'inactivated' || value === 'canceled') {
  //   return 'orange--text darken-3'
  // }
  else if (value.toLowerCase() === "interrupting") {
    return "grey--text";
  } else if (value.toLowerCase() === "interrupted") {
    return "grey--text text--darken-5";
  } else if (value.toLowerCase() === "awaiting_contract_generation") {
    return "teal--text text--lighten-1";
  } else if (value.toLowerCase() === "awaiting_signature") {
    return "purple--text text--darken-1";
  }
  // else if(value === 'canceling') {
  //   return 'orange--text darken-3'
  // }
  else if (value.toLowerCase() === "error") {
    return "orange--text";
  } else if (value.toLowerCase() === "bill_not_found") {
    return "orange--text";
  } else if (value.toLowerCase() === "disqualified") {
    return "red--text text--darken-3";
  } else if (value.toLowerCase() === "pending") {
    return "grey--text";
  } else if (value.toLowerCase() === "qualified") {
    return "blue--text";
  } else return "grey--text";
});

// A data no banco de dados é uma string no formato YYYY-MM-DD, então é necessário inverter para DD-MM-YYYY
Vue.filter("formatStringToDate", (value) => {
  if (!value || value === "") return value;
  const new_value = value.split("-");
  return `${new_value[2]}/${new_value[1]}/${new_value[0]}`;
});

// O valor no banco de dados é em centavos, então é necessário dividir por 100
Vue.filter("formatXMLValue", (value) => {
  if (!value) return value;
  const new_value = (value / 100).toString().replace(".", ",");
  return new_value;
});

Vue.filter("formatProcessType", (value) => {
  if (!value) return "PDF";
  if (value === "xml") return "XML";
  else if (value === "manual") return "Planilha";
  else if (value === "empty_billing") return "Fatura em branco";
  else return value;
});

function search(nameKey, myArray) {
  for (var i = 0; i < myArray.length; i++) {
    if (myArray[i].value === nameKey) {
      return myArray[i].text;
    }
  }
}
